import { render, staticRenderFns } from "./PostcodecheckerV2.vue?vue&type=template&id=0c956573&scoped=true"
import script from "./PostcodecheckerV2.vue?vue&type=script&lang=js"
export * from "./PostcodecheckerV2.vue?vue&type=script&lang=js"
import style0 from "./PostcodecheckerV2.vue?vue&type=style&index=0&id=0c956573&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c956573",
  null
  
)

export default component.exports